import { createAsyncThunk } from '@reduxjs/toolkit';
import { createSliceRequest } from '../../../../shared/store/sliceRequest';
export const createConversation = createSliceRequest('assistant/createConversation', async ({ api, usageContext, agentMode }) => {
    var _a;
    const response = await api.createConversation(usageContext, agentMode);
    const conversation = {
        id: response.id,
        root_conversation_id: response.root_conversation_id,
        created_by_id: response.created_by_id,
        created_by_type: response.created_by_type,
        created_at: response.created_at,
        updated_at: response.updated_at,
        title: response.title,
        usage_context: response.usage_context,
        program_id: response.program_id,
        company_name: response.company_name,
        application_display: response.application_display,
        agent_mode: response.agent_mode,
        messages: (_a = response.messages) !== null && _a !== void 0 ? _a : [],
    };
    return conversation;
});
export const getConversation = createSliceRequest('assistant/getConversation', async ({ api, conversationId }) => {
    const response = await api.getConversation(conversationId);
    return response;
});
export const getConversations = createSliceRequest('assistant/getConversations', async ({ api }) => {
    const response = await api.getConversations();
    return response;
});
export const deleteMessage = createAsyncThunk('assistant/deleteMessage', async ({ api, messageId, conversationId }, { dispatch }) => {
    await api.deleteMessage(messageId);
    await dispatch(getConversation({ api, conversationId }));
    return { messageId, conversationId };
});
export const updateConversationTitle = createAsyncThunk('assistant/updateConversationTitle', async ({ api, conversationId, title }) => {
    await api.updateConversationTitle(conversationId, title);
    return { conversationId, title };
});
export const conversationThunkHandlers = {
    [createConversation.pending.type]: (_state, _action) => {
    },
    [createConversation.fulfilled.type]: (_state, _action) => {
    },
    [createConversation.rejected.type]: (_state, _action) => {
    },
};
